module.exports = __webpack_public_path__ + "img/mosaic-nav-btn.a60a2214.png";